import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    description: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
    },
    tableContainer: {
      backgroundColor: theme.palette.common.white,
      borderRadius: '8px',
      overflow: 'hidden',
      marginTop: 15,
    },
    tableHead: {
      backgroundColor: '#E3E7EB',
    },
    tableHeadCell: {
      color: '#98A5B7',
      fontWeight: 700,
      fontSize: '11px',
      textTransform: 'uppercase',
      lineHeight: '16px',
    },
    tableRow: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#FFF',
      },
      '&:hover': {
        backgroundColor: '#F6F8FB',
      },
    },
    tableCell: {
      borderBottom: '1px solid #E0E6ED',
      fontSize: '12px',
      color: colorVariables.navy,
      padding: '8px 10px',
    },
    deliveryType: {
      color: '#98A5B7',
      fontWeight: 400,
    },
    deliveryThreshold: {
      fontWeight: 700,
    },
    daySettings: {
      fontWeight: 700,
    },
    noSettings: {
      paddingLeft: '24px',
      fontWeight: 700,
      color: '#98A5B7'
    },
    ruleNameCell: {
      fontWeight: 600,
      color: '#444',
    },
    iconButton: {
      display: 'flex',
      alignItems: 'center',
    },
    editIcon: {
      color: '#51D9B0',
      fontSize: 16,
      cursor: 'pointer',
    },
    deleteIcon: {
      color: '#EA6363',
      fontSize: 16,
      cursor: 'pointer',
    },
    addRuleLink: {
      color: '#33A8E2',
      fontWeight: 600,
      fontSize: '14px',
      marginTop: 10,
      textTransform: 'none',
    },
    emptyMessage: {
      textAlign: 'center',
      padding: '16px',
      color: colorVariables.navy,
    },
    dialog: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    topUpSwitch: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20,
    },
    topUpText: {
      fontSize: 12,
      fontWeight: 700,
    },
    track: {
      backgroundColor: colorVariables.steelGrey,
      opacity: 1,
    },
    thumb: {
      backgroundColor: colorVariables.white,
      width: 20,
      height: 20,
    },
    checked: {
      '&.MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#44B5E6',
        opacity: 1,
      },
    },
  }),
);


